import { Bell } from 'lucide-react'
import { useUnreadAlertCount } from '../../hooks/use-alerts'

interface AlertBadgeProps {
  onClick?: () => void
}

export function AlertBadge({ onClick }: AlertBadgeProps) {
  const { data: count = 0, isLoading } = useUnreadAlertCount()

  return (
    <button
      onClick={onClick}
      className="relative p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
      title="Alertas"
    >
      <Bell className="w-5 h-5" />
      {!isLoading && count > 0 && (
        <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] flex items-center justify-center px-1 text-xs font-medium text-white bg-red-500 rounded-full">
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  )
}
